import './Skeleton.css';

export function Skeleton({ variant = 'text', style, className = '', as: Tag = 'div' }) {
  return <Tag className={`skeleton skeleton-${variant} ${className}`} style={style} />;
}

/* Ladeanzeige für die langen Listen.

   Vorher standen hier nur graue Balken ohne Beschriftung. Grau und leer sieht
   aus wie „nichts da", nicht wie „warte kurz" — und genau das war die Klage.
   Deshalb steht jetzt ein Wort davor, und die Balken zeichnen sich nacheinander
   ein statt alle gleichzeitig zu pulsieren.

   role="status" mit aria-live="polite" sagt es auch denen, die den Bildschirm
   nicht sehen; ohne das bleibt das Laden für sie stumm. */
export function SkeletonTable({ rows = 6, label = 'Wird geladen' }) {
  return (
    <div className="skeleton-wrap" role="status" aria-live="polite">
      <span className="skeleton-label">
        {label}<span className="skeleton-dots" aria-hidden="true">…</span>
      </span>
      {Array.from({ length: rows }).map((_, i) => (
        /* Der Versatz lässt die Balken von oben nach unten erscheinen — als
           würde die Liste gezeichnet. Alle gleichzeitig wirkt wie Flackern. */
        <Skeleton key={i} variant="row" style={{ animationDelay: `${i * 90}ms` }} />
      ))}
    </div>
  );
}
